<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 469.1 519.8" xml:space="preserve">
    <g>
      <g>
        <path
          d="M132.5,249l-20.6,35.7l-2,3.4l1,3.8l7.4,27.7l-68,117.8L13.2,416l102.1-177L132.5,249 M145.6,245.5l-33.8-19.5L0,419.5
			l53.8,31.1L128.6,321l-8.4-31.5L145.6,245.5L145.6,245.5z" />
        <path
          d="M92.8,93.4l31.8,30.8l-73,126.5l-26.5-40.1L92.8,93.4 M90.7,78L13.9,211l38.3,58l84.5-146.4L90.7,78z" />
        <path
          d="M272.3,329.7l-102.2,177L133,485.2L201,367.3l27.7-7.4l3.8-1l2-3.4l20.6-35.7L272.3,329.7 M285.5,326.2l-33.8-19.5
			l-25.4,44l-31.5,8.4l-74.9,129.6l53.8,31.1L285.5,326.2L285.5,326.2z" />
        <path
          d="M409.7,276.3L342,393.5l-47.9-2.9l73-126.5L409.7,276.3 M424.1,270.5l-61.6-17.6L278,399.3l69.3,4.2L424.1,270.5
			L424.1,270.5z" />
      </g>
    </g>
    <g>
      <path
        d="M359.8,87.2l-2.7,45.6l-0.4,5.9l5.1,3l94.2,54.4l-21.6,37.5l-84.2-24.1l-7.2-2.1l-3.8,6.5l-31,53.7l-47.2-2.8l-4-0.2
		l-3,2.6l-51.2,45.4l-37.9-21.9l13.7-67.1l0.8-3.9l-2.2-3.3l-26-39.5l31-53.7l3.7-6.5l-5.4-5.2l-63-60.9l21.6-37.5l94.2,54.4l5.1,3
		l5-3.3l38.1-25.2L359.8,87.2 M284.5,127.3l-9-33.4l-2.5-9.3l-9.2,2.4l-17.1,4.6l-9.3,2.5l2.5,9.3l9,33.4l-33.4,9l-9.4,2.5l2.5,9.3
		l4.6,17.1l2.5,9.3l9.3-2.5l33.4-9l9,33.4l2.5,9.3l9.3-2.5l17.1-4.6l9.3-2.5l-2.5-9.3l-9-33.4l33.5-9l9.3-2.5l-2.5-9.3l-4.6-17.1
		l-2.5-9.3l-9.3,2.5L284.5,127.3 M369.7,81.8l-88.4-51l-43,28.4L135.7,0l-30.2,52.3l68.4,66.1l-33.9,58.8l29.3,44.4l-15.1,73.9
		l49.9,28.8l56.4-50l53.1,3.2l33.9-58.8l91.4,26.2l30.2-52.3l-102.5-59.2L369.7,81.8L369.7,81.8z M277.7,139l42.7-11.4l4.6,17.1
		l-42.6,11.5l11.5,42.7l-17.1,4.6l-11.4-42.7l-42.7,11.4l-4.6-17.1l42.7-11.4l-11.4-42.7l17.1-4.6L277.7,139L277.7,139z" />
    </g>
  </svg>
</template>
